import React from "react";
import Navbar from "@/components/Navbar";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, BookOpen } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

const knowledgeCalls = [
  { title: "Share Standards-Aligned Curriculum Mapping Workflows", relatedTo: "Curriculum Standards & Frameworks" },
  { title: "Submit District Operational Playbooks for Budget Optimization", relatedTo: "District Governance & Administration" },
  { title: "Contribute Evidence-Based Literacy Intervention Data", relatedTo: "Student Assessment & Accountability" },
  { title: "Add Teacher Retention Strategies from High-Turnover Districts", relatedTo: "Teacher Workforce Management" },
  { title: "Share Accreditation Self-Study Best Practices", relatedTo: "Academic Program Design & Accreditation" },
  { title: "Submit Faculty Mentorship Program Designs", relatedTo: "Faculty Governance & Tenure Systems" },
  { title: "Contribute Student Success Early Alert System Configurations", relatedTo: "Student Success & Retention Models" },
  { title: "Add CTE Pathway Outcome Data from State Programs", relatedTo: "Career & Technical Education" },
  { title: "Share AI Tutoring Implementation Case Studies", relatedTo: "AI Tutoring & Adaptive Learning" },
  { title: "Submit FERPA Compliance Audit Templates", relatedTo: "Cybersecurity & Data Privacy" },
];

const EducationCallForKnowledge = () => {
  const navigate = useNavigate();

  const handleCallClick = (callTitle: string, relatedTo: string) => {
    navigate("/call-for-knowledge/bounty", {
      state: {
        selectedArea: "Education Operations",
        chevronCall: {
          title: callTitle,
          relatedTo,
          organization: "Education Channel",
          bountyAmount: "2000",
          bountyType: "Enterprise",
          contributors: ["Education Channel", "Giblet"],
          description: `Education Channel seeks knowledge contributions for: ${callTitle}. This knowledge request aims to capture field expertise and operational insights to enhance educational outcomes.`,
        },
      },
    });
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <Link to="/education-channel">
            <Button variant="ghost" className="mb-4">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Education Channel
            </Button>
          </Link>
          <h1 className="text-4xl font-bold text-foreground mb-4">Education Demonstration</h1>
          <p className="text-lg text-muted-foreground max-w-4xl mb-6">
            These are invitations to contribute new knowledge — typically from field experiences, institutional systems, or underrepresented workflows.
          </p>
        </div>

        <Card className="mb-8">
          <CardHeader className="pb-6">
            <CardTitle className="flex items-center gap-2 text-2xl">
              <BookOpen className="h-6 w-6" />
              Calls for Knowledge (CfK)
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid gap-4">
              {knowledgeCalls.map((call, index) => (
                <Card key={index} className="border border-muted hover:border-primary/20 transition-colors">
                  <CardContent className="p-6">
                    <button
                      className="text-lg font-semibold text-foreground hover:text-primary transition-colors cursor-pointer text-left"
                      onClick={() => handleCallClick(call.title, call.relatedTo)}
                    >
                      CfK: {call.title}
                    </button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default EducationCallForKnowledge;
